var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 13,
    viewBox: "0 0 32 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1877_4736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7406 1.51184L11.165 11.8045H13.6849L15.2617 1.51184H12.7406Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05291 1.52347L6.58491 8.54275L6.32177 7.48289C5.83504 6.20587 4.45327 4.37187 2.83105 3.21606L5.08777 11.7995L7.75409 11.7945L11.7225 1.5213L9.05291 1.52347Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.36523 2.26002C5.21876 1.63306 4.79425 1.44619 4.26733 1.42383H0.36053L0.328125 1.62873C3.36841 2.44977 5.38014 4.42807 6.2149 6.80679L5.36523 2.26002Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3688 3.48509C21.1932 3.47066 21.7908 3.67124 22.2548 3.87902L22.4823 3.99807L22.8232 1.76725C22.3242 1.55874 21.5419 1.33508 20.5658 1.33508C18.0758 1.33508 16.3207 2.73115 16.3071 4.73181C16.2909 6.21012 17.5573 7.0355 18.5139 7.52827C19.4958 8.03331 19.8251 8.35437 19.8205 8.80529C19.8127 9.4943 19.0376 9.81031 18.3137 9.81031C17.3046 9.81031 16.7686 9.65519 15.9409 9.27137L15.6162 9.10687L15.2617 11.4106C15.8515 11.6984 16.9397 11.9459 18.0693 11.9589C20.7182 11.9589 22.4395 10.5794 22.4577 8.44166C22.4687 7.27214 21.7966 6.37967 20.3403 5.64737C19.4589 5.16975 18.9196 4.8523 18.9248 4.37035C18.9248 3.94251 19.3824 3.48509 20.3688 3.48509Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2899 1.52338H27.343C26.7383 1.52338 26.2885 1.70663 26.0228 2.37761L22.2812 11.8102H24.9275C24.9275 11.8102 25.3591 10.5419 25.457 10.2641C25.7467 10.2641 28.3177 10.2684 28.6839 10.2684C28.7591 10.6277 28.9911 11.8102 28.9911 11.8102H31.3289L29.2899 1.52338ZM26.1822 8.15739C26.3896 7.5665 27.1861 5.28085 27.1861 5.28085C27.1725 5.30898 27.3916 4.68562 27.5219 4.29819L27.6917 5.18561C27.6917 5.18561 28.1745 7.64297 28.2756 8.15739H26.1822Z",
    fill: "#FCFCFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1877_4736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.0602,
    height: 12.079,
    fill: "white",
    transform: "translate(0.328125 0.60791)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo);
export default __webpack_public_path__ + "static/media/visa-logo.9ba69d29c114b54a0b15cf62fb410368.svg";
export { ForwardRef as ReactComponent };